import { HistoryContext } from "context";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useHistoryContext = () =>
  useProviderInitializedContext(HistoryContext);
